import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=c8d7e588&scoped=true&"
import script from "./LegalInfo.vue?vue&type=script&lang=js&"
export * from "./LegalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=c8d7e588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d7e588",
  null
  
)

export default component.exports